import { CourseType } from '@app/store/shared/models';
import { Time } from '@app/shared/classes';
import { CourseValue } from './course.value';

export class CourseValueDto {
    name: string;
    description: string;
    learningType: CourseType;
    objectives: string[];
    instructorId: string | null;
    tagIds: string[];
    moduleIds?: string[];
    materialIds?: string[];
    mediaPlaceholderId?: string | null;
    mediaPlaceholderPortraitId?: string | null;
    deadline?: string | null;
    orderRestricted?: boolean;

    constructor(data: CourseValue) {
        this.name = data.name;
        this.description = data.description;
        this.learningType = data.type;
        this.objectives = data.objectives;
        this.instructorId = data.instructorId;
        this.tagIds = data.tagIds;

        if (data.moduleIds !== undefined) {
            this.moduleIds = data.moduleIds;
        }

        if (data.materialIds !== undefined) {
            this.materialIds = data.materialIds;
        }

        // Only send mediaPlaceholderId if changed from original
        if (data.mediaPlaceholderId !== undefined && data.mediaPlaceholderId !== data.originalMediaPlaceholderId) {
            this.mediaPlaceholderId = data.mediaPlaceholderId;
        }

        // Only send mediaPlaceholderPortraitId if changed from original
        if (data.mediaPlaceholderPortraitId !== undefined && data.mediaPlaceholderPortraitId !== data.originalMediaPlaceholderPortraitId) {
            this.mediaPlaceholderPortraitId = data.mediaPlaceholderPortraitId;
        }

        if (data.deadline !== undefined) {
            this.deadline = data.deadline ? Time.dateToString(data.deadline) : null;
        }

        if (data.orderRestricted !== undefined) {
            this.orderRestricted = data.orderRestricted;
        }
    }
}
